import React from 'react';
import PropTypes from 'prop-types';

class List extends React.PureComponent {
  render() {
    let { children, className, component: ComponentProp, ...other } = this.props;
    const Component = ComponentProp || 'ul';

    return (
      <Component className={className} {...other}>
        {children}
      </Component>
    );
  }
}

List.propTypes = {
  className: PropTypes.string,
  component: PropTypes.oneOf(['ul', 'ol']),
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const List = ({prop = val, component = 'ul', className = '' }) =>

export default List;
